module.exports = "/cyber/_next/static/images/winners-bg-mobile-b6ee6c7bcc721a4278f4e0de4ab0363b.jpg";